export default "__VITE_ASSET__ac2513d6__"